

































































import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import {
  defineComponent,
  toRefs,
  ref,
  computed,
  watch
} from '@nuxtjs/composition-api'
import { useSwipe } from '~/compositions/swipe'
import CImageViewer from '~/components/shared/configurable/image/CImageViewer.vue'

export default defineComponent({
  components: { CImageViewer },
  props: {
    urls: {
      type: Array,
      required: true,
      default: () => []
    },
    imageSize: { type: String, default: null },
    halfSizeNavTriggers: { type: Boolean, default: false },
    imageTag: { type: String, default: 'img' },
    swipeable: { type: Boolean, default: false },
    disableZoomer: { type: Boolean, default: false },
    galleryInSearch: { type: Boolean, default: false },
    contain: { type: Boolean, default: false }
  },

  setup(props, { emit }) {
    const { urls, imageSize, swipeable, disableZoomer } = toRefs(props)
    const imgIndex = ref(0)
    const fadeClass = ref(null)
    const fadeTimeout = ref(null)
    const showZoomer = ref(false)
    const icons = computed(() => ({
      leftArrow: faChevronLeft,
      rightArrow: faChevronRight
    }))
    const swipeableElement = ref<HTMLElement | null>(null)

    const normalizedUrls = computed(() => {
      if (imageSize.value) {
        return (urls.value.value = urls.value.map((u: string) =>
          u.replace('{size}', imageSize.value)
        ))
      }
      return urls.value
    })

    const filesToShow = computed(() => {
      return urls.value.map(u => {
        return {
          type: 'image',
          url: u.replace('{size}', 'b'),
          name: null
        }
      })
    })

    const selectedImgUrl = computed(() => {
      return normalizedUrls.value?.length
        ? normalizedUrls.value[imgIndex.value]
        : null
    })

    const onSwipeLeft = () => {
      handleNext()
    }
    const onSwipeRight = () => {
      handlePrev()
    }

    const { enableSwipe, disableSwipe, getDragging } = useSwipe(
      swipeableElement,
      onSwipeLeft,
      onSwipeRight,
      swipeable.value
    )

    watch(swipeable, newValue => {
      if (newValue) {
        enableSwipe()
      } else if (disableSwipe) {
        disableSwipe()
      }
    })

    const handleImageClick = () => {
      if (!getDragging()) {
        emit('click')
        forceShowNavBtns()
        if (!disableZoomer.value) {
          showZoomer.value = true
        }
      }
    }
    const forceShowNavBtns = () => {
      fadeClass.value = '!tw-opacity-100'
      clearTimeout(fadeTimeout.value)
      fadeTimeout.value = setTimeout(() => (fadeClass.value = null), 4000)
    }
    const handleNext = () => {
      forceShowNavBtns()
      if (imgIndex.value < normalizedUrls.value.length - 1) {
        emit('next', imgIndex.value)
        imgIndex.value++
      }
    }
    const handlePrev = () => {
      forceShowNavBtns()
      if (imgIndex.value > 0) {
        imgIndex.value--
        emit('prev', imgIndex.value)
      }
    }

    return {
      selectedImgUrl,
      icons,
      fadeClass,
      handleNext,
      handlePrev,
      forceShowNavBtns,
      handleImageClick,
      swipeableElement,
      normalizedUrls,
      imgIndex,
      showZoomer,
      filesToShow
    }
  }
})
